<div class="sso-rate-limitation-wrapper">
  <div class="sso-rate-limitation-container">
    <div class="sso-rate-limitation__content">
      <h1 class="sso-rate-limitation__title" [translate]="'GlobalNav:NavSsoRateLimitationTitle'">Too many attempts</h1>
      <p class="sso-rate-limitation__message" [translate]="'GlobalNav:NavSsoRateLimitationBody'">
        you've tried too many times. For your security, this session is closed.
      </p>
      <div class="sso-rate-limitation__logout-button">
        <button mat-raised-button color="primary" (click)="logOut()" tabindex="0">
          <span [translate]="'GlobalNav:NavLogout'"></span>
        </button>
      </div>
    </div>
  </div>
</div>
